import React from 'react';
import classNames from 'classnames';

const ToolbarButton = ({active, ...rest}) => (
    <button className={classNames('btn btn-outline-dark', {active})} {...rest} type="button" />
);

export default ToolbarButton;
